<template>
  <div class="a4-container" id="pdf-content">
    <!-- <span style="position: absolute; right: 400px; top: 100px !important"
      >D2029220420</span
    > -->
    <div
      style="text-align: center; font-size: 16pt"
      :style="'margin-top: ' + ui_setting.top1 + 'px;font-size: '+ui_setting.fontSize1+'pt'"
    >
      <i>
        Монгол Улсын иргэн
        <strong style="text-transform: uppercase">{{
          student.lastName
        }}</strong>
        овогтой
        <strong style="text-transform: uppercase">{{
          student.firstName
        }}</strong></i
      >
    </div>
    <div
      style="
        text-align: center;
        margin-left: 10px;
        margin-right: 10px;
      "
      
      :style="'margin-top: ' + ui_setting.top2 + 'px;font-size: '+ui_setting.fontSize2+'pt'"
    >
      <p
        style="margin-top: 0px !important; margin-bottom: 0px !important"
        v-if="student.profession"
      >
        ТЕХНИК ТЕХНОЛОГИЙН ДЭЭД СУРГУУЛЬ-д
      </p>
      <p style="margin-top: 0px !important; margin-bottom: 0px !important">
        <strong class="red--text" style="text-transform: uppercase">{{
          student.profession.name
        }}</strong>
      </p>
      <p style="margin-top: 0px !important; margin-bottom: 0px !important">
        хөтөлбөр (<span class="red--text">{{
          student.profession.xcurriculumIndex
        }}</span
        >)-өөр 2018 оноос 2022 онд суралцаж
      </p>

      <p style="margin-top: 0px !important; margin-bottom: 0px !important">
        төгссөн тул төгсөлтийн шалгалтын комиссын
      </p>
      <p style="margin-top: 0px !important; margin-bottom: 0px !important">
        {{ ui_setting.decisionText }}
      </p>
      <p style="margin-top: 0px !important; margin-bottom: 0px !important">
    
        {{ ui_setting.tushaalText }}
      </p>
      <p style="margin-top: 0px !important; margin-bottom: 0px !important">
        <strong
          v-if="student.profession && student.profession.xprofessiondegree"
          class="red--text"
          style="text-transform: uppercase"
          ><span class="blue--text">{{ student.profession.name }}ийн</span>
          {{ student.profession.xprofessiondegree.name }}</strong
        >-ын зэрэг олгов.
      </p>
    </div>
    <div
      style="display: flex; justify-content: center; align-items: center"
      :style="'margin-top: ' + ui_setting.top3 + 'px'"
    >
      <table class="btable" style="width: 100%" :style="'font-size: '+ui_setting.fontSize3+'pt'">
        <tr>
          <td style="text-align: center !important; padding: 0px; width: 33%">
            <p
              style="margin-top: 0px !important; margin-bottom: 0px !important"
            >
              ______________________________
            </p>
            Удирдаx зөвлөлийн дарга
          </td>
          <td style="text-align: center !important; padding: 0px; width: 33%">
            <p
              style="margin-top: 0px !important; margin-bottom: 0px !important"
            >
              _______________________________________
            </p>
            Төгсөлтийн шалгалтын комиссын дарга
          </td>
          <td style="text-align: center !important; padding: 0px; width: 33%">
            <p
              style="margin-top: 0px !important; margin-bottom: 0px !important"
            >
              ______________________________
            </p>
            Сургалт, оюутны албаны дарга
          </td>
        </tr>
        <tr>
          <td style="text-align: center !important; padding: 0px; width: 33%">
            xүндэт доктор
          </td>
          <td style="text-align: center !important; padding: 0px; width: 33%">
            Заxирал, профессор
          </td>
          <td
            style="
              text-align: center !important;
              padding: 0px;
              width: 33%;
              font-weight: bold;
              padding-top: 10px;
            "
          >
            Б.МЯГМАРДОРЖ
          </td>
        </tr>
        <tr>
          <td
            style="text-align: center !important; padding: 0px; width: 33%"
          ></td>
          <td
            style="text-align: center !important; padding: 0px; width: 33%"
          ></td>
          <td
            style="text-align: center !important; padding: 0px; width: 33%"
          ></td>
        </tr>
        <tr>
          <td
            style="
              text-align: center !important;
              padding: 0px;
              width: 33%;
              font-weight: bold;
              padding-top: 10px;
            "
          >
            Б.НЭМЭXБААТАР
          </td>
          <td
            style="
              text-align: center !important;
              padding: 0px;
              width: 33%;
              font-weight: bold;
              padding-top: 10px;
            "
          >
            Ц.БАЯРМАА
          </td>
          <td
            style="
              text-align: center !important;
              padding: 0px;
              width: 33%;
              font-weight: bold;
              padding-top: 10px;
            "
          ></td>
        </tr>
      </table>
    </div>

    <span
      style="position: absolute; margin-bottom: 0px !important"
      :style="
        'bottom: ' +
        ui_setting.bottom1 +
        'px!important;  left:' +
        ui_setting.left1 +
        'px;'
      "
      >Улаанбаатар xот</span
    >

    <span
      style="position: absolute; right: 100px; margin-bottom: 0px !important"
      :style="
        'bottom: ' +
        ui_setting.bottom1 +
        'px!important;  left:' +
        ui_setting.left2 +
        'px;'
      "
      >{{ ui_setting.printAtDateText }}</span
    >

    <span
      style="position: absolute; right: 98.26px; margin-bottom: 0px !important"
      :style="'bottom: ' + ui_setting.bottom1 + 'px!important'"
      >Бүртгэлийн дугаар: {{student.diplomaRegisterNumber}}</span
    >
  </div>
</template>
    
<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("@/firebaseConfig.js");
export default {
  data() {
    return {};
  },
  // computed: {
  //   ...mapState(["userProfile", "currentUser", "xxschoolPath"]),
  // },
  // created() {
  //   console.log("abc",this.userProfile);
  //   this.userProfile.school.ref.collection("_settings-ui").doc("diploma-template-ui").onSnapshot(doc=>{
  //     this.ui_setting = doc.data()
  //     this.ui_setting.ref = doc.ref
  //     this.ui_setting.id = doc.id
  //   })
  // },
  props: {
    student: {
      required: true,
      type: Object,
    },
    ui_setting: {
      required: true,
      type: Object,
    },
  },
};
</script>
<style>
@media print {
  @page {
    size: landscape;
    margin: 0;
  }

  body {
    margin: 0;
  }
}
.btable {
  border-collapse: collapse;
  border: 1px solid black;
}
.btable th,
td {
  border: 1px solid black;
  padding: 8px;
}

.a4-container {
  position: relative;
  width: 29.7cm;
  height: 21cm;
  border: 1px solid black;
  margin: 0 auto;
}
.a4-container .main-text {
  display: inline-block;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  margin: 0 auto;
  box-sizing: border-box;
}

.a4-container .bottom-container {
  position: relative;
  bottom: 100px;
  display: flex;
  justify-content: space-between;
  height: 100px;

  padding-left: 40px;
  padding-right: 40px;
}

.a4-container .bottom-container .signature {
  border-top: 1px solid black;
  padding-top: 4px !important;
  margin-left: 30px;
  margin-right: 30px;
  width: 33%;
}
.signature .pclass {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.a4-container .head-score-page {
  position: relative;
  top: 10px;
  display: flex;
  justify-content: space-between;
  border: 1px solid black;
}

.a4-container .score-main {
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid red;
}
.a4-container .head-score-page .title-column {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 2px;
  width: 30%;
  height: 80%;
  background-color: lightgray;
}
.a4-container .head-score-page .title-column .column-text {
  text-align: left;
  padding: 2px;
  width: 50%;
  background-color: lightgray;
}
.a4-container .score-main .score-table-column {
  padding: 2px;
  width: 30%;
  height: 80%;
  background-color: lightgray;
}
.a4-container .score-signature-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid blue;
}
.a4-container .score-signature-container .score-signature {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 40%;
  background-color: lightgray;
}
.bordered-table {
  border-collapse: collapse;
  width: 100%;
}

.bordered-table th,
.bordered-table td {
  border: 1px solid black;
  padding: 8px;
}
.title-column .upper {
  text-transform: uppercase;
  font-weight: bold;
}
</style>